import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react';

const SelectOptionWithAvailability = ({ innerProps, data }) => {
  const {
    label,
    icon,
    showIcon = true,
    iconProps = {},
    availability,
    isDisabled,
  } = data;

  return (
    <Flex
      {...innerProps}
      gap="5px"
      alignItems="center"
      padding="10px 10px"
      mx="6px"
      _hover={{
        bg: '#F4F4F5',
        borderRadius: '5px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
      opacity={isDisabled && '0.5'}
    >
      {showIcon && (
        <Icon as={icon} width="20px" height="20px" {...iconProps} mr="5px" />
      )}
      <Flex justifyContent="space-between" flex="1">
        <KText size="sm-regular">{label}</KText>
        {availability === 0 && (
          <KText size="sm-regular">
            {availability === null
              ? 'Error'
              : availability > 0
              ? ''
              : 'Limit reached (wait 24h)'}
          </KText>
        )}
      </Flex>
    </Flex>
  );
};

export default SelectOptionWithAvailability;
